import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { validaSoloNumero, validaNumeroTelefono, validaEmail } from '../../util/varios';
import moment from 'moment';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';


export const ActualizarPersona = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const [activate, setActivate] = useState(false);
    const [msg, setMsg] = useState();
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [persona, setPersona] = useState({ cedula: '', nombres: '', apellidos: '', direccion: '', correoe: '', tlf1: '', tlf2: '', fnacimiento: '', nacionalidad: '', sexo: '' });
    const [tecla, setTecla] = useState();
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [body, setBody] = useState({});
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtCedula = useRef();
    const txtNombre = useRef();
    const txtApellido = useRef();
    const txtDireccion = useRef();
    const txtEmail = useRef();
    const txtTlf = useRef();
    const txtCel = useRef();
    const txtFechaNac = useRef();
    const cmbNacionalidad = useRef();
    const cmbSexo = useRef();
    const edad = parseInt(moment.utc(fechaSistema).format('YYYY')) - 18;
    const limiteEdad = edad + '-' + moment.utc(fechaSistema).format('MM-DD').toString();



    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);

        if (props.operacion) {
            setOperacion(props.operacion);
        }


    }, [props.operacion]);

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        var valido;
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.id === 'inputTlf') {
                txtCel.current.focus();
            } else if (event.target.id === 'inputCel') {
                txtFechaNac.current.focus();
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        var mensaje = '';
        if (txtCedula.current.value.trim() === '') {
            mensaje = 'La cedula no debe estar vacia';
            sigue = false;
            txtCedula.current.focus();
        } else if (txtNombre.current.value.trim() === '') {
            mensaje = 'Los nombres no deben estar vacios';
            sigue = false;
            txtNombre.current.focus();
        } else if (txtApellido.current.value.trim() === '') {
            mensaje = 'Los Apellidos no deben estar vacio';
            sigue = false;
            txtApellido.current.focus();
        } else if (txtDireccion.current.value.trim() === '') {
            mensaje = 'La direccion del  no debe estar vacia';
            sigue = false;
            txtDireccion.current.focus();
        } else if (txtFechaNac.current.value.trim() === '') {
            mensaje = 'La fecha de nacimiento no debe estar vacia';
            sigue = false;
            txtFechaNac.current.focus();
        }

        if (sigue) {

            var datoPer = [];
            /*   datoPer.push({
                  apellidos: txtApellido.current.value.trim().toUpperCase(),
                  cedula: txtCedula.current.value,
                  correoe: txtEmail.current.value,
                  direccion: txtDireccion.current.value.trim().toUpperCase(),
                  fnacimiento: txtFechaNac.current.value.toUpperCase(),
                  nacionalidad: cmbNacionalidad.current.value,
                  nombres: txtNombre.current.value.trim().toUpperCase(),
                  sexo: cmbSexo.current.value,
                  tlf1: txtTlf.current.value,
                  tlf2: txtCel.current.value
              })
              setPersona(datoPer); */
            let body = {
                operacion: operacion,
                cedula: txtCedula.current.value,
                correoe: txtEmail.current.value,
                tlf1: txtTlf.current.value,
                tlf2: txtCel.current.value,
                apellidos: txtApellido.current.value.trim(),
                direccion: txtDireccion.current.value.trim(),
                fnacimiento: txtFechaNac.current.value,
                nacionalidad: cmbNacionalidad.current.value,
                nombres: txtNombre.current.value.trim(),
                sexo: cmbSexo.current.value,
            };
            setBody(body);
            let msg = '';
            if (props.operacion === 1) {
                msg = 'Esta Seguro de Registrar estos Datos.';
            } else if (props.operacion === 2) {
                msg = 'Esta Seguro de Modificar estos Datos.';
            } else if (props.operacion === 3) {
                msg = 'Esta Seguro de Eliminar estos Datos.';
            }
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
        }

    };

    const cancelar = () => {

        blanquear();

        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
    };

    const procesarRegistro = () => {

        let endpoint = `${op.conexion}/api/configuracion/actualizarpersona`;

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {



                setActivate(false);
                var mensaje = '';
                if (operacion === 1) {
                    mensaje = 'La Persona ' + txtCedula.current.value + ' ha sido registrada de manera satisfactoria.';
                } else if (operacion === 2) {
                    mensaje = 'La Persona ' + txtCedula.current.value + ' ha sido modificada de manera satisfactoria.';
                } else if (operacion === 3) {
                    mensaje = 'La Persona ' + txtCedula.current.value + ' ha sido eliminada de manera satisfactoria.';
                }


                setMensaje({ mostrar: true, titulo: 'Exito.', texto: mensaje, icono: 'exito' });

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }

    const validarPersona = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                setTecla(event.which);
            } else {
                txtNombre.current.value = '';
            }
        }
    };

    const onChange = (event) => {
        if (event.target.id === 'inputNombres') {

            event.target.value = event.target.value.toUpperCase()
        } else if (event.target.id === 'inputApellidos') {

            event.target.value = event.target.value.toUpperCase()
        } else if (event.target.id === 'inputDireccion') {

            event.target.value = event.target.value.toUpperCase()
        } else if (event.target.id === 'inputEmail') {

            event.target.value = event.target.value.toUpperCase()
        }
    }

    const handleInputChange = (event) => {
        if (event.which === 13) {
            var valido;
            if (event.target.id === 'inputNombres') {

                txtApellido.current.focus();
            } else if (event.target.id === 'inputApellidos') {

                txtDireccion.current.focus();
            } else if (event.target.id === 'inputDireccion') {

                txtEmail.current.focus();
            } else if (event.target.id === 'inputEmail') {
                txtTlf.current.focus()
            } else if (event.target.id === 'inputFechaNac') {
                cmbNacionalidad.current.focus();
            }
        } else if (typeof (event.which) === 'undefined') {
          /*   if (event.target.id === 'inputEmail') {
                

            } else */ if (event.target.id === 'inputTlf') {
                txtCel.current.focus();
            } else if (event.target.id === 'inputCel') {
                txtFechaNac.current.focus();
            } else {
                return false;
            }

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro();
    };

    const cerrarModal = () => {

        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideAcepta();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                setDeshabilitado(props.deshabilitado);


            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{operacion === 1 ? 'Agregar Persona.' : operacion === 2 ? 'Editar Persona.' : operacion === 3 ? 'Eliminar Persona.' : 'Consultar Persona.'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='col-md-12 bg-light mx-auto row rounded px-0'>

                    <div className="input-group  mb-2  input-group-sm col-sm-4">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Cedula:</label>
                        <select className="form-select col-md-3" disabled={deshabilitado} ref={cmbNacionalidad} aria-label="Default select example " defaultValue={props.persona && props.persona.nacionalidad !== null ? props.persona.nacionalidad.trim() : ''} id="inputNac" >
                            <option key="0" value="V">V</option>
                            <option key="1" value="J">J</option>
                            <option key="2" value="E">E</option>
                        </select>
                        <input type="text" className="form-control text-uppercase" disabled={operacion === 2 ? true : deshabilitado} autoComplete='off' ref={txtCedula} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona && props.persona.cedula ? props.persona.cedula !== '' ? props.persona.cedula.trim() : '' : ''} id="inputCedula" onKeyUp={validarPersona} onBlur={validarPersona} />
                    </div>
                    <div className='col-sm-5'></div>
                    <div className="input-group  mb-2  input-group-sm col-sm-3">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Sexo:</label>
                        <select className="form-select" disabled={deshabilitado} ref={cmbSexo} aria-label="Default select example " defaultValue={props.persona ? props.persona.sexo.trim() : ''} id="inputSexo" >
                            <option key="0" value="M">M</option>
                            <option key="1" value="F">F</option>
                        </select>
                    </div>

                    <div className="input-group  mb-2  input-group-sm col-sm-6">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Nombres:</label>
                        <input type="text" className="form-control text-uppercase" disabled={deshabilitado} autoComplete='off' ref={txtNombre} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona && props.persona.cedula ? props.persona.nombres !== '' ? props.persona.nombres.trim() : '' : ''} id="inputNombres" onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={onChange} />
                    </div>

                    <div className="input-group  mb-2  input-group-sm col-sm-6">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Apellidos:</label>
                        <input type="text" className="form-control text-uppercase" disabled={deshabilitado} autoComplete='off' ref={txtApellido} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona && props.persona.apellidos !== '' ? props.persona.apellidos.trim() : ''} id="inputApellidos" onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={onChange} />
                    </div>

                    <div className="input-group  mb-2  input-group-sm col-sm-12">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Direccion:</label>
                        <textarea type="textarea" style={{ height: 40 }} className="form-control text-uppercase" disabled={deshabilitado} autoComplete='off' ref={txtDireccion} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona && props.persona.direccion !== '' ? props.persona.direccion.trim() : ''} id="inputDireccion" onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={onChange} />
                    </div>


                    <div className="input-group  mb-2  input-group-sm col-sm-4">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Telefono:</label>
                        <input type="text" className="form-control text-uppercase" disabled={deshabilitado} autoComplete='off' ref={txtTlf} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona && props.persona.tlf1 ? props.persona.tlf1 !== '' ? props.persona.tlf1.trim() : '': ''} id="inputTlf" onKeyUp={handleInputNumChange} onBlur={handleInputNumChange} onChange={onChange} />
                    </div>

                    <div className="input-group  mb-2  input-group-sm col-sm-4">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Celular:</label>
                        <input type="text" className="form-control text-uppercase" disabled={deshabilitado} autoComplete='off' ref={txtCel} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona && props.persona.tlf2 ? props.persona.tlf2 !== '' ? props.persona.tlf2.trim() : '' : ''} id="inputCel" onKeyUp={handleInputNumChange} onBlur={handleInputNumChange} onChange={onChange} />
                    </div>

                    <div className="input-group  mb-2  input-group-sm col-sm-4 pl-0">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Fecha Nacimiento:</label>
                        <input type="date" className="form-control text-uppercase" disabled={deshabilitado} ref={txtFechaNac} max={limiteEdad} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona && props.persona.fnacimiento ? props.persona.fnacimiento !== '' ? moment.utc(props.persona.fnacimiento).format('YYYY-MM-DD') : '' : ''} id="inputFnac" onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={onChange} />
                    </div>
                    <div className='col-md-5'></div>

                    
                    <div className="input-group  mb-2  input-group-sm col-sm-12">
                        <label className="input-group-text" id="inputGroup-sizing-sm">E-mail:</label>
                        <input type="text" className="form-control text-uppercase" disabled={deshabilitado} autoComplete='off' ref={txtEmail} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" defaultValue={props.persona ? props.persona.correoe !== '' ? props.persona.correoe : '' : ''} id="inputEmail" onKeyUp={handleInputChange} onBlur={handleInputChange} onChange={onChange} />
                    </div>
            
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} onClick={onChangeValidar} disabled={operacion === 4 ? true : false} style={{ margin: '1px' }} className="col-sm-2 btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i>Aceptar</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="col-sm-2 btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i>Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}